export default __webpack_public_path__ + "static/media/correctrightarrow.45780520.svg";